<template>
  <div class="contain" style="padding: 2.25rem 5vw">
    <div style="display: flex; flex-wrap: wrap; justify-content: space-between">
      <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">
        學生表現 <span style="white-space: nowrap">Learning Performance</span>
        <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
          <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin-right: 1rem"></span>
          <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin-right: 1rem"></span>
          <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin-right: 1rem"></span>
        </div>
      </div>
      <div class="purchase-box" style="flex-wrap: wrap;display: flex;
  justify-content: center;
  align-items: center;">
        &nbsp;學生:&nbsp;
        <el-select v-model="selectUserId" placeholder="學生" @change="handleUserSelect" style="width: auto">
          <el-option
              v-for="item in studentCardList"
              :key="item.id"
              :label="item.userNo"
              :value="item.id">
          </el-option>
        </el-select>
        &nbsp;年級:&nbsp;
        <el-select @change="gradeChange" v-model="selectGradeId" clearable placeholder="全部 All">
          <el-option v-for="(item, index) in grades" :key="index" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
    </div>

    <div>
      <el-row :gutter="24"> <!-- 添加行容器，设置间距 -->
        <el-col :span="24"> <!-- 左侧文本列，占6/24宽度 -->
          <div class="grid-content bg-purple" style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; color: #b62d2e">
            整體
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <div class="grid-content bg-purple-light" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100px;">
            <p style="font-size: 4rem; line-height: 1rem; font-weight: bold; color: #b62d2e">{{ learningPerformanceData.star }}/{{learningPerformanceData.totalStar}}</p>
            <p style="font-size:24px">星星總數</p>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100px;">
            <p style="font-size: 4rem; line-height: 1rem; font-weight: bold; color: #b62d2e">{{ learningPerformanceData.overallPerformance }}</p>
            <p style="font-size:24px">整體表現</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <img src="@/assets/images/bear3.png" height="200px">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark x2" style="height: 100px;display: flex;justify-content: flex-end;align-items: center;">
            <p style="font-size:24px;color: white;margin-right: 100px;">學生：{{ selectUserNo }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 20px;">
      <el-row :gutter="24">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-card shadow="always" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <span style="font-size: 1.8rem; line-height: 1rem;">答題總數&nbsp;&nbsp;</span>
            <span style="font-size: 1.8rem; line-height: 1rem; font-weight: bold; color: #b62d2e">{{ learningPerformanceData.totalScore }}</span>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-card shadow="always" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <span style="font-size: 1.8rem; line-height: 1rem;">總學習時間&nbsp;&nbsp;</span>
            <span style="font-size: 1.8rem; line-height: 1rem; font-weight: bold; color: #b62d2e">{{ learningPerformanceData.totalAnsweringMinutes }}分鐘</span>
          </el-card>
        </el-col>
<!--        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">-->
<!--          <el-card shadow="always" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">-->
<!--            <span style="font-size: 1.8rem; line-height: 1rem;">平均准確率&nbsp;&nbsp;</span>-->
<!--            <span style="font-size: 1.8rem; line-height: 1rem; font-weight: bold; color: #b62d2e">25%</span>-->
<!--          </el-card>-->
<!--        </el-col>-->
      </el-row>
    </div>
    <div style="margin-top: 20px;">
      <el-row :gutter="24">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; color: #b62d2e">表現最佳冒險</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="onDetailStudent">MORE</el-button>
            </div>
            <div v-for="(its, idx) in learningPerformanceData.topThreeProgresses" :key="idx" class="text item" style="font-size: 24px; line-height: 2rem;">
              {{its.topic.name == ''? its.topic.number:its.topic.name}}
              <div style="float: right;" type="text">
                <template>
                  <img style="height: 20px;" :src="its.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 20px;" :src="its.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 20px;" :src="its.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                </template>
              </div>

            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-size: 1.5rem; line-height: 2rem; font-weight: bold; color: #b62d2e">表現最弱冒險</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="onDetailStudent">MORE</el-button>
            </div>
            <div v-for="(its, idx) in learningPerformanceData.bottomThreeProgresses" :key="idx" class="text item" style="font-size: 24px; line-height: 2rem;">
              {{its.topic.name == ''? its.topic.number:its.topic.name}}
              <div style="float: right;" type="text">
                <template>
                  <img style="height: 20px;" :src="its.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 20px;" :src="its.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 20px;" :src="its.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                </template>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { gender, paymentType } from "@/biz/static-data";
import { formatDate } from "@/filters";
import { getSubscriptionUpgradeDates } from "@/api/setting";
import {getLearningPerformance} from "@/api/topic";
import {getGrades} from "@/api/grade";
export default {
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      grades: [],
      selectUserId:null,
      selectUserNo:null,
      selectGradeId:null,
      studentAccountFrom: {
        id: null,
        userNo: null,
        name: null,
        gender: null,
        school: null,
        password: null,
        gradeId: null,
        avatar: null,
      },
      studentCardList: [],
      paymentType: [],
      studentIndex: null,
      dialogVisible: false,
      confirmUpgradeDate: "",
      autoUpgradeDate: "",
      learningPerformanceData: {}
    };
  },
  watch: {//使用watch监听数据变化（适用于动态加载数据）
    studentCardList: {
      handler() {
        if (this.studentCardList.length > 0) {
          this.selectUserId = this.studentCardList[0].id;
          this.selectUserNo = this.studentCardList[0].userNo;
          this.selectGradeId = this.studentCardList[0].subscriptions[this.studentCardList[0].subscriptionIndex].gradeId;
        }
      },
      immediate: true // 初始化时执行一次
    },
    "$store.getters.language": {
      handler(v) {
        //  this.getCarts()
        this.genders = gender[v];
        this.paymentType = paymentType[v];
        this.$forceUpdate();
      },
      deep: true,
    },
    detail(v) {
      this.studentCardList = v.students.filter((item) => {
        return item.subscriptions.length > 0 && item.status == 1;
      });
      this.$forceUpdate();
    },
  },
  computed: {
    needRenew() {
      let need = false;
      if (this.detail.students && this.detail.students.length > 0) {
        this.detail.students.forEach((item) => {
          if (item.status == 1 && !item.studentCode) {
            if (item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex) && item.subscriptionIndex == 0 && this.checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) != 0)
              need = true;
            if (item.subscriptions.length == 0) need = true;
          }
        });
      }
      return need;
    },
    needUpgrade() {
      if (this.confirmUpgradeDate && this.autoUpgradeDate) return this.$options.filters["isBetween"](new Date(), this.confirmUpgradeDate, this.autoUpgradeDate);
      else return false;
    },
  },
  created() {},
  mounted() {
    this.paymentType = paymentType[this.$store.getters.language];
    if (this.detail.students) {
      this.studentCardList = this.detail.students.filter((item) => {
        return item.subscriptions.length > 0 && item.status == 1;
      });
    }
    getSubscriptionUpgradeDates().then((v) => {
      let year = new Date().getFullYear() + "-";
      this.confirmUpgradeDate = year + v.data.confirmUpgradeDate;
      this.autoUpgradeDate = year + v.data.autoUpgradeDate;
    });

    setTimeout(() => {
      this.learningPerformance();
    }, 500);
    this.getGrades();
  },
  methods: {
    enName(gradeName) {
      let enGradeList = {
        小一: "Primary One",
        小二: "Primary Two",
        小三: "Primary Three",
        小四: "Primary Four",
        小五: "Primary Five",
        小六: "Primary Six",
      };
      return enGradeList[gradeName];
    },
    gradeChange(id) {
      this.selectGradeId=id;
      this.learningPerformance();
    },
    getGrades() {
      getGrades().then((v) => {
        this.grades = v.data;
        this.$forceUpdate();
      });
    },
    learningPerformance() {
      let form = {
        studentId: this.selectUserId,
        gradeId: this.selectGradeId
      };
      getLearningPerformance(form).then((v) => {
        this.learningPerformanceData = v.data;
      });
    },
    handleUserSelect(selectedId) {
      // 方法1：通过selectedId查找label（适用于value是id的场景）
      const selectedItem = this.studentCardList.find(item => item.id === selectedId);
      if (selectedItem) {
        const label = selectedItem.userNo;
        this.selectUserId = selectedId;
        this.selectUserNo = label;
        this.selectGradeId = selectedItem.subscriptions[selectedItem.subscriptionIndex].gradeId;
      }
      this.learningPerformance();
    },
    formatDate(date) {
      return formatDate(date);
    },
    onDetailStudent() {
      this.$router.push({
        path: "/studyRecord",
        query: {
          id: this.selectUserId,
          studentName: this.selectUserNo,
          gradeId: 1,
        },
      });
// selectGradeId:null,
    },
    childByValue(v) {
      this.dialogVisible = v;
      this.$emit("getProfile");
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="scss" scoped>
.x2 {
  background-image: url("~@/assets/images/x2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-size: 100% 100%;
}
.contain {
  //width: 100%;
  display: flex;
  flex-direction: column;
}
.purchase-box {
  display: flex;
  justify-content: flex-end;
  position: relative;
  //margin-top: -4.5rem;
  height: 3.75rem;
  height: 3.75rem;
}
.el-icon-warning {
  font-size: 2rem;
  color: #d20000;
  position: absolute;
  top: -1rem;
  margin-left: 1rem;
}
.student-box {
  margin-top: 3rem;
}
.card-box {
  margin-bottom: 1.25rem;
  padding: 1rem;
  background: #f1aa55 url("~@/assets/images/student-card.png") top left/64% auto;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  img {
    margin: 1rem auto;
    width: 7.5rem;
    height: 7.5rem;
  }
  .card-detail {
    background: #ffffff;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    .card-detail-text {
      padding-bottom: 1rem;
      display: flex;
      div:nth-child(1) {
        color: #8e8e8e;
        flex: 1;
      }
      div:nth-child(2) {
        color: #444444;
        flex: 2;
      }
    }
  }
  .text-warn {
    color: #d20000;
  }
  .text-success {
    color: #008000;
  }
  .text-info {
    color: #936a10;
  }
  .box-warn {
    background: #fbe6e6;
    border: 1px #d20000 solid;
    margin-top: 1.25rem;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    display: flex;
  }
  .box-success {
    background: #e6f2e6;
    border: 1px #008000 solid;
    margin-top: 1.25rem;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    display: flex;
  }
  .box-info {
    background: #fffbe6;
    border: 1px #ffd700 solid;
    margin-top: 1.25rem;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    display: flex;
  }
  .box-icon {
    font-size: 1.6rem;
    margin-right: 0.5rem;
  }
  .box-info-icon {
    font-size: 1.2rem;
    padding: 0.2rem;
    line-height: 1;
    margin-right: 0.5rem;
    color: #fffbe6;
    background: #fcc03a;
    border-radius: 50%;
  }
}
.detail-button {
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  color: #444444;
  border-radius: 1.625rem;
  font-size: 18px;
  line-height: 1;
  padding: 0.75rem 2.25rem;
  background: #fcc03a;
  margin-bottom: 0.5rem;
  &.disabled {
    opacity: 0.6;
  }
}
.card-button {
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  color: #444444;
  border-radius: 1.625rem;
  line-height: 1.25;
  min-height: 2.2rem;
  background: #ffffff;
}

@media (min-width: $minWidth) and (max-width: $maxWidth) {
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .contain {
    height: 100%;
  }
  .el-dialog__wrapper {
    top: auto;
  }
}
::v-deep {
  .el-dialog {
    border-radius: 2.25rem;
    .el-dialog__headerbtn {
      font-size: 1.6rem;
      top: 2rem;
      right: 2rem;
    }
    .el-dialog__body {
      padding: 3rem 1.25rem;
    }
  }
}
</style>
